export const NIVO_CHART_TEXT_COLOR = "var(--text-color)";
export const NIVO_CHART_GRID_COLOR = "var(--glass-color)";

const nivoTheme = {
  text: {
    fill: NIVO_CHART_TEXT_COLOR,
  },
  axis: {
    ticks: {
      line: {
        stroke: NIVO_CHART_TEXT_COLOR,
      },
      text: {
        fill: NIVO_CHART_TEXT_COLOR,
        fontWeight: 700,
      },
    },
    legend: {
      text: {
        fill: NIVO_CHART_TEXT_COLOR,
        fontWeight: 700,
      },
    },
  },
  grid: {
    line: {
      stroke: NIVO_CHART_GRID_COLOR,
    },
  },
  labels: {
    text: {
      fill: NIVO_CHART_TEXT_COLOR,
    },
  },
  legends: {
    text: {
      fill: NIVO_CHART_TEXT_COLOR,
    },
  },
  tooltip: {
    container: {
      background: "var(--bg-color8)",
      color: NIVO_CHART_TEXT_COLOR,
      border: "1px solid var(--glass-color)",
    },
  },
};

export default nivoTheme;
